export default "__VITE_ASSET__Dd04B0qf__"